import cn from "@/lib/cn";

interface CardOnFileStatusBadgeProps {
  hasCard: boolean;
}

export function CardOnFileStatusBadge({ hasCard }: CardOnFileStatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-lg px-2.5 py-1 text-[11px] font-semibold",
        hasCard ? "bg-[#E6F9EE] text-[#00A67F]" : "bg-[#FEF2F2] text-[#FF2D00]",
      )}
    >
      <div
        className={cn(
          "size-[5px] rounded-[3px]",
          hasCard ? "bg-[#00A67F]" : "bg-[#FF2D00]",
        )}
      />
      {hasCard ? "Active" : "No Card"}
    </span>
  );
}
